import { styled } from '@mui/system';
export const IconPad = styled('span')({
  paddingRight:'3px'
});
export default IconPad;

